import React, {  useEffect,useState } from "react";
import ReactDOM from "react-dom";
import {
  getProductListByModel,
  toggleProductStatus,
  insertProductDiscounts,
  updateProductDiscounts,
    getMenu1 ,
} from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";
import { Modal, Input, Checkbox, Button, Select } from "antd";

const CreateProductDiscount = () => {
  const [modelNo, setModelNo] = useState("");
  const [products, setProducts] = useState([]);
  const [searched, setSearched] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [discountRows, setDiscountRows] = useState([
    { fromqty: "", toqty: "", discount: "", type: "" },
  ]);
    const [menuData, setMenuData] = useState([]);

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [updateRows, setUpdateRows] = useState([]);

  /* ================= SEARCH ================= */

  const handleSearch = async () => {
    try {
      const res = await getProductListByModel(modelNo);
      setProducts(Array.isArray(res?.data) ? res.data : []);
      setSearched(modelNo);
    } catch (err) {
      console.error(err);
      setProducts([]);
    }
  };

  /* ================= TOGGLE ================= */

  const handleToggle = async (id, currentStatus) => {
    try {
      await toggleProductStatus(id, currentStatus ? 0 : 1);

      setProducts((prev) =>
        prev.map((p) =>
          p.productid === id ? { ...p, active: currentStatus ? 0 : 1 } : p
        )
      );
    } catch (err) {
      console.error("Toggle failed", err);
    }
  };

  /* ================= CREATE DISCOUNT ================= */

  const handlePostClick = (productId) => {
    setSelectedProductId(productId);
    setDiscountRows([{ fromqty: "", toqty: "", discount: "" }]);
    setShowModal(true);
  };

  const addRow = () => {
    setDiscountRows([...discountRows, { fromqty: "", toqty: "", discount: "", type: "" }]);
  };

  const handleRowChange = (index, field, value) => {
    const updated = [...discountRows];

    updated[index] = {
      ...updated[index],
      [field]: value
    };

    setDiscountRows(updated);
  };

  const handleSaveDiscount = async () => {
    for (let i = 0; i < discountRows.length; i++) {
      const row = discountRows[i];

      if (!row.fromqty || !row.toqty || !row.discount || !row.type) {
        showSnackbar("error", `All fields required in row ${i + 1}`);
        return;
      }

      if (isNaN(row.fromqty) || isNaN(row.toqty) || isNaN(row.discount)) {
        showSnackbar("error", `Only numbers allowed in row ${i + 1}`);
        return;
      }

      if (Number(row.fromqty) > Number(row.toqty)) {
        showSnackbar("error", `From QTY must be less than or equal to To QTY (row ${i + 1})`);
        return;
      }
    }

    const payload = discountRows.map((row) => ({
      productid: selectedProductId,
      fromqty: Number(row.fromqty),
      toqty: Number(row.toqty),
      discount: Number(row.discount),
      type: row.type,
      active: 1,
    }));

    try {
      await insertProductDiscounts(payload);

      showSnackbar("success", "Discounts saved successfully");

      setShowModal(false);
      setDiscountRows([{ fromqty: "", toqty: "", discount: "", type: "" }]);
    } catch (err) {
      console.error(err);
      showSnackbar("error", "Failed to save discounts");
    }
  };
const modelOptions = menuData.flatMap((category) =>
  (category.Subcategory || []).flatMap((sub) =>
    (sub.dtls || []).map((item) => ({
      value: item.modelno,
      label: item.modelno,
      productid: item.productid,
    }))
  )
);
 const styles = {
  input: {
    padding: "10px 12px",
    width: "240px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "14px",
    outline: "none",
  },

  searchButton: {
    padding: "10px 18px",
    backgroundColor: "#005487", // blue
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
  },

  th: {
    padding: "12px",
    backgroundColor: "#f8fafc",
    color: "#334155",
    fontSize: "13px",
    fontWeight: "600",
    textAlign: "center",
    borderBottom: "1px solid #e5e7eb",
  },

  td: {
    padding: "12px",
    fontSize: "13px",
    color: "#475569",
    textAlign: "center",
    borderBottom: "1px solid #e5e7eb",
  },

  actionBtn: {
    padding: "6px 12px",
    backgroundColor: "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    fontSize: "12px",
    cursor: "pointer",
    transition: "0.2s ease",
    marginRight:"10px"
  },
};
  /* ================= UPDATE DISCOUNT ================= */
  const openUpdateModal = (product) => {
    setUpdateRows(product); // make sure p is array
    setIsUpdateModalOpen(true);
    const discounts = product.Qtydiscounts || [];

    const rows = discounts.map((d) => ({
      productid: product.productid,
      discountid: d.discountid,
      fromqty: d.fromqty,
      toqty: d.toqty,
      discount: d.discount,
      type: d.type || "",
      active: d.active,
    }));

    setUpdateRows(rows);
    setIsUpdateModalOpen(true);
  };

  const handleUpdateRowChange = (index, field, value) => {
    const updated = [...updateRows];
    updated[index][field] = value;
    setUpdateRows(updated);
  };

  const handleUpdateDiscount = async () => {
    try {
      const payload = updateRows.map((row) => ({
        productid: row.productid,
        discountid: row.discountid,
        fromqty: Number(row.fromqty),
        toqty: Number(row.toqty),
        discount: Number(row.discount),
        type: row.type,
        active: row.active,
      }));

      console.log("Final Payload:", payload); // ✅ debug

      await updateProductDiscounts(payload); // 🔥 send array

      showSnackbar("success", "Discount updated successfully");
      setIsUpdateModalOpen(false);
    } catch (err) {
      console.error(err);
      showSnackbar("error", "Update failed");
    }
  };
    useEffect(() => {
    const fetchMenu = async () => {
      try {
        const data = await getMenu1();
        setMenuData(data);
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchMenu();
  }, []);
  

  /* ================= UI ================= */

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ color: "green" }}>Create Product Discount</h2>

      {/* SEARCH */}
      <div style={{ display: "flex", gap: 10 }}>
   <input
  type="text"
  list="model-options"
  placeholder="Enter or select model number"
  value={modelNo}
  onChange={(e) => setModelNo(e.target.value)}
   style={styles.input}
/>

<datalist id="model-options">
  {modelOptions.map((item) => (
    <option key={item.productid} value={item.value} />
  ))}
</datalist>

        <button style={{
          backgroundColor: "#006098",
          padding: "6px 12px",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          marginRight: 5
        }} disabled={!modelNo} onClick={handleSearch}>
          Search
        </button>
      </div>

      {searched && <p>Results for: {searched}</p>}

      {/* TABLE */}

      <table border="1" width="100%" cellPadding="8">
        <thead>
          <tr>
            <th>Model</th>
            <th>Product ID</th>
            <th>Brand</th>
            <th>Dealer Min Qty</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {products.length === 0 ? (
            <tr>
              <td colSpan="6">No products found</td>
            </tr>
          ) : (
            products.map((p) => (
              <tr key={p.productid}>
                <td>{p.modelno}</td>
                <td>{p.productid}</td>
                <td>{p.brand}</td>
                <td>{p.dealerminqty}</td>

                <td>
                  <input
                    type="checkbox"
                    checked={p.active === 1}
                    onChange={() =>
                      handleToggle(p.productid, p.active === 1)
                    }
                  />
                </td>

                <td>
                  <button style={{
                    backgroundColor: "#006098",
                    padding: "6px 12px",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    marginRight: 5
                  }} onClick={() => handlePostClick(p.productid)}>
                    Post
                  </button>

                  <button style={{
                    backgroundColor: "#006098",
                    padding: "6px 12px",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer"
                  }} onClick={() => openUpdateModal(p)}>
                    Update
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* ================= CREATE MODAL ================= */}

      <Modal
        title="Post Discount"
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
      >
        {/* Product ID */}
        <Input
          value={selectedProductId}
          disabled
          style={{ marginBottom: 10 }}
        />

        {/* Rows */}
        {discountRows.map((row, i) => (
          <div key={i} style={{ display: "flex", gap: 8, marginBottom: 10 }}>

            <Input
              placeholder="From Qty"
              value={row.fromqty}
              onChange={(e) =>
                handleRowChange(i, "fromqty", e.target.value)
              }
            />

            <Input
              placeholder="To Qty"
              value={row.toqty}
              onChange={(e) =>
                handleRowChange(i, "toqty", e.target.value)
              }
            />

            <Input
              placeholder="Discount"
              value={row.discount}
              onChange={(e) =>
                handleRowChange(i, "discount", e.target.value)
              }
            />

            <Select
              placeholder="Type"
              value={row.type || undefined}
              onChange={(val) => handleRowChange(i, "type", val)}
              style={{ width: 100 }}
              options={[
                { value: "pcs", label: "Piece" },
                { value: "pack", label: "Pack" },
                { value: "cart", label: "Cart" },
                { value: "extra1", label: "Ext 1" },
                { value: "extra2", label: "Ext 2" },
                { value: "extra3", label: "Ext 3" },
              ]}
            />
          </div>
        ))}

        {/* Add Row */}
        <Button onClick={addRow} style={{ marginBottom: 15 }}>
          + Add Row
        </Button>

        {/* Actions */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>

          <Button type="primary" onClick={handleSaveDiscount}>
            Save
          </Button>
        </div>
      </Modal>

      {/* ================= UPDATE MODAL ================= */}

      <Modal
        title="Update Discount"
        open={isUpdateModalOpen}
        onCancel={() => setIsUpdateModalOpen(false)}
        footer={null}  // custom buttons
      >
        {updateRows?.map((row, i) => (
          <div key={i} style={{ display: "flex", gap: 10, marginBottom: 10 }}>

            <Input value={row.discountid} disabled style={{ width: 100 }} />

            <Input
              value={row.fromqty}
              onChange={(e) =>
                handleUpdateRowChange(i, "fromqty", e.target.value)
              }
              placeholder="From"
            />

            <Input
              value={row.toqty}
              onChange={(e) =>
                handleUpdateRowChange(i, "toqty", e.target.value)
              }
              placeholder="To"
            />

            <Input
              value={row.discount}
              onChange={(e) =>
                handleUpdateRowChange(i, "discount", e.target.value)
              }
              placeholder="Discount"
            />

            <Select
              placeholder="Type"
              value={row.type || undefined}
              onChange={(val) => handleUpdateRowChange(i, "type", val)}
              style={{ width: 100 }}
              options={[
                { value: "piece", label: "Piece" },
                { value: "pack", label: "Pack" },
                { value: "cart", label: "Cart" },
                { value: "extra1", label: "Ext1" },
                { value: "extra2", label: "Ext2" },
                { value: "extra3", label: "Ext3" },
              ]}
            />

            <Checkbox
              checked={row.active === "1"}
              onChange={(e) =>
                handleUpdateRowChange(i, "active", e.target.checked ? 1 : 0)
              }
            >
              Active
            </Checkbox>
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <Button onClick={() => setIsUpdateModalOpen(false)}>Cancel</Button>

          <Button type="primary" onClick={handleUpdateDiscount}>
            Update
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default CreateProductDiscount;